export const QUOTATION_STATUS_CREATED = 1;
export const PAYMENT_CAPTURED_STATUS = 5;
export const PAYMENT_NOT_CAPTURED_STATUS = 6;
export const POLICY_STATUS_AWAITED = 20;
export const POLICY_STATUS_SUCCESS = 21;
export const POLICY_STATUS_FAILED = 22;
export const POLICY_STATUS_NEED_INSURED_REVIEW = 24;
export const POLICY_STATUS_ON_HOLD = 34;

export const PAYMENT_CAPTURED = "Payment Captured";
export const PAYMENT_PENDING = "Payment Pending";
export const POLICY_CANCELLED = "Policy Cancelled";
export const POLICY_CANCELLATION_INITIATED = "Policy Cancellation Initiated";
export const POLICY_CREATED = "Policy Created";
export const POLICY_CREATION_FAILED = "Policy Creation Failed";
export const POLICY_DETAILS_AWAITED = "Policy Details Awaited";
export const POLICY_DOCUMENTS_PENDING = "Documents Pending";
export const POLICY_NEED_INSURED_REVIEW = "Need Insurer Review";
export const POLICY_ON_HOLD = "Policy On Hold";
export const QUOTATION_CREATED = "Quotation Created";
